module.exports = __webpack_public_path__ + "static/media/facebook.86e53adf.svg";